import {IconTypes} from "@irati/ui/src/Icon"

interface PerkboxBenefitIcon {
  text: string
  img: string
}
export interface PerkboxBenefit {
  text: string
  img: string
  linkText: string
  link: string
  bgImg: string
  action: string
  subproduct: string
  icons: PerkboxBenefitIcon[]

  icon?: IconTypes
  titleColor?: string
  benefitId?: string
}

const benefitMarketplace: PerkboxBenefit = {
  text: "admin.components.dashboard.benefits.marketplace.text",
  img: "admin.components.dashboard.benefits.marketplace.img",
  linkText: "admin.components.dashboard.benefits.marketplace.ctaText",
  link: "admin.components.dashboard.benefits.marketplace.link",
  bgImg: "admin.components.dashboard.benefits.marketplace.bgImg",
  action: "cta_viewMarketplace",
  subproduct: "marketplace",
  icons: [
    {
      text: "admin.components.dashboard.benefits.icons.medical.text",
      img: "admin.components.dashboard.benefits.icons.medical.img"
    },
    {
      text: "admin.components.dashboard.benefits.icons.wellness.text",
      img: "admin.components.dashboard.benefits.icons.wellness.img"
    },
    {
      text: "admin.components.dashboard.benefits.icons.dental.text",
      img: "admin.components.dashboard.benefits.icons.dental.img"
    },
    {
      text: "admin.components.dashboard.benefits.icons.optical.text",
      img: "admin.components.dashboard.benefits.icons.optical.img"
    },
    {
      text: "admin.components.dashboard.benefits.icons.childcare.text",
      img: "admin.components.dashboard.benefits.icons.childcare.img"
    },
    {
      text: "admin.components.dashboard.benefits.icons.cycle.text",
      img: "admin.components.dashboard.benefits.icons.cycle.img"
    },
    {
      text: "admin.components.dashboard.benefits.icons.tech.text",
      img: "admin.components.dashboard.benefits.icons.tech.img"
    },
    {
      text: "admin.components.dashboard.benefits.icons.gym.text",
      img: "admin.components.dashboard.benefits.icons.gym.img"
    },
    {
      text: "admin.components.dashboard.benefits.icons.car.text",
      img: "admin.components.dashboard.benefits.icons.car.img"
    },
    {
      text: "admin.components.dashboard.benefits.icons.financial.text",
      img: "admin.components.dashboard.benefits.icons.financial.img"
    },
    {
      text: "admin.components.dashboard.benefits.icons.legal.text",
      img: "admin.components.dashboard.benefits.icons.legal.img"
    }
  ]
}

export default benefitMarketplace
